import * as localStorageKeys from './localStorageKeys';

const AppVal = {
  // 여기는 CONSTANT_CASE로 정의된 것들을 불러서 쓴다.
  // 설정 개념이 아닌 고정된 문자열이나 숫자값
  // pc 환경에서만 사용할거
  SIDE_BAR_WIDTH: 280,
  MAIN_AREA_PADDING: 24,
  MAIN_AREA_OUTER_WIDTH: 948,
  MAIN_AREA_INNER_WIDTH: 900,
  NAV_BAR_HEIGHT: 65,
  DRAWER_WIDTH_WIDE: 360,
  DRAWER_WIDTH_NARROW: 320,

  DRAG_ITEM_NEW_HOMEWORK: 'DRAG_ITEM_NEW_HOMEWORK',
  DRAG_ITEM_EXISTING_HOMEWORK: 'DRAG_ITEM_EXISTING_HOMEWORK',
  DRAG_ITEM_LESSON_REPORT_TEMPLATE_ITEM: 'DRAG_ITEM_LESSON_REPORT_TEMPLATE_ITEM',
  DRAG_ITEM_BILL_EDU_EXPENSE_CERTIFICATE: 'DRAG_ITEM_BILL_EDU_EXPENSE_CERTIFICATE',

  ...localStorageKeys,
};

export default AppVal;
